/**
 * ReCAPTCHA token key in the request header.
 */ const RECAPTCHA_TOKEN = 'recaptcha-token';
/**
 * ReCAPTCHA action key in the request header.
 */ const RECAPTCHA_ACTION = 'recaptcha-action';
/**
 * Cypress flag indicating that the reCAPTCHA hook is being rendered in the Cypress test environment.
 */ const CYPRESS_FLAG = 'cypress';
/**
 * Fallback token for onCompleted callback when onError callback is undefined.
 */ const RECAPTCHA_FALLBACK_TOKEN = 'recaptcha-client-error';

export { CYPRESS_FLAG, RECAPTCHA_ACTION, RECAPTCHA_FALLBACK_TOKEN, RECAPTCHA_TOKEN };
//# sourceMappingURL=index.js.map
